import { obterPorData } from '../../util/Data'

export default class MontaPacote {
    
    static obter = dados => {

        return new Promise((resolve,reject) => {
            try {
                const pacote = {
                    denuncia:{},
                    fotocopias:[]
                }
                const contato = dados.dadosPessoais
                if (contato.email !== "" || contato.nome !== "" || contato.telefone !== "") {
                    pacote.denuncia.contato = contato
                }
                pacote.denuncia.local = dados.local
                pacote.denuncia.narrativa = dados.denuncia
                if (dados.dataAcontecimento !== "") {
                    pacote.denuncia.data = obterPorData(dados.dataAcontecimento).formatadaSQL
                }
                atualizarPessoasEnvolvidas(pacote.denuncia,dados.pessoasEnvolvidas)
                atualizarPostagens(pacote.denuncia,dados.links)
                atualizarAnexos(pacote.fotocopias,dados.anexosDto)
                resolve(pacote)
            } 
            catch (msgErro) {
                reject(msgErro)
            }
        })
    }
}

const atualizarPessoasEnvolvidas = (denuncia,pessoasEnvolvidas) => {
    if (!pessoasEnvolvidas) {
        return
    }
    if (pessoasEnvolvidas.length === 0) {
        return
    }
    denuncia.pessoasEnvolvidas = pessoasEnvolvidas
}

const atualizarPostagens = (denuncia,links) => {
    if (!links) {
        return
    }
    if (links.length === 0) {
        return
    }

    denuncia.postagens = []
    let postagem = null
    for (let i=0; i<links.length; i++) {
        postagem = links[i]
        denuncia.postagens.push({ url: postagem.link })
    }
}

const atualizarAnexos = (fotocopias,anexosDto) => {
    if (!anexosDto) {
        return
    }
    if (anexosDto.length === 0) {
        return
    }

    let fotoCopia = null;
    for (let i=0; i<anexosDto.length; i++) {
        fotoCopia = anexosDto[i]
        fotocopias.push({ 
            data: fotoCopia.base64Imagem, 
            contentType: fotoCopia.imagemContentType,
            fileName: fotoCopia.nomeArquivo 
        })
    }
}